<ng-container *sbPageAction>
  <sb-button *ngIf="!preselectType" classes="btn-primary btn-sm" (click)="save()">{{'lang.globals.save'}}</sb-button>
</ng-container>


<div style="min-height: 170px;">
  <div *ngIf="loading" [@fadeInOut]
       style="background: rgba(255, 255, 255, 1); top: 0; left: 0; height: 100%; width: 100%; z-index: 50; text-align: center;">
    <sb-icon class="spinner" icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}"
             [style.color]="'#004F90'"></sb-icon>
  </div>
  <div *ngIf="!loading" [@fadeInOut]>
    <ng-container *ngIf="DEBUGGING">
      Formula: {{fetchcull ? fetchcull.expression : ''}}
    </ng-container>
    <div class="my-4 d-flex justify-content-center">
      <sb-button *ngIf="!disabled" classes="btn-primary" (click)="addRow(false)">
        <sb-icon icon="plus" class="mr-2"></sb-icon>
        {{'lang.culls.addRow' | translate}}</sb-button>
    </div>
    <sb-filter-definition-row [disabled]="disabled" *ngFor="let row of rows; let i = index"
                              [inDeleteProcess]="inDeleteProcess"
                              [rowIndex]="i"
                              [(leftOperators)]="row.left"
                              [(atom)]="row.atom" [(rightOperators)]="row.right" [cull]="fetchcull"
                              [setup]="fetchsetup"
                              [singleSetup]="row.setup" (deleteClick)="deleteRow(i)" [atomTypes]="atomTypes"
                              (changesEmitter)="refreshCullAndEmit()">
    </sb-filter-definition-row>

    <div class="my-4 d-flex justify-content-center">
      <sb-button *ngIf="!disabled && rows?.length > 0" classes="btn-primary" (click)="addRow(true)">
        <sb-icon icon="plus" class="mr-2"></sb-icon>
        {{'lang.culls.addRow' | translate}}</sb-button>
    </div>
  </div>
</div>
